import type { FC } from 'react';

import { DynamicPriceCardElectricityV2Rendering } from '@sitecore/types/DynamicPriceCardElectricityV2';

import { CurrentDynamicPriceCard } from './CurrentDynamicPriceCard';

const DynamicPriceCardElectricity: FC<DynamicPriceCardElectricityV2Rendering> = () => (
  <CurrentDynamicPriceCard product={'electricity'} />
);

export { DynamicPriceCardElectricity };
export default DynamicPriceCardElectricity;
